import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Pageable, WrapperPageableResponse } from './service-common';
import { SATCFDIUseDTO } from '../core/models';

export type WrapperPageableResponseSATCFDIUseDTO = WrapperPageableResponse<SATCFDIUseDTO>;

export type SATCFDIUseFilterSpec = Record<string, unknown>;

@Injectable({
  providedIn: 'root'
})
export class SATCFDIUseService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  list(
    spec: SATCFDIUseFilterSpec = {},
    pageable: Pageable = { page: 0, size: 200 }
  ): Observable<WrapperPageableResponseSATCFDIUseDTO> {
    let params = new HttpParams();

    Object.entries(spec).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, String(value));
      }
    });

    params = params.append('page', String(pageable.page));
    params = params.append('size', String(pageable.size));

    if (pageable.sort && pageable.sort.length > 0) {
      pageable.sort.forEach(sort => {
        params = params.append('sort', sort);
      });
    }

    return this.http.get<WrapperPageableResponseSATCFDIUseDTO>(
      `${this.apiUrl}/sat-cfdi-uses`,
      { params }
    );
  }
}
